<template>
  <div class="content b-t">
    <div
      class="list border-bottom"
      v-for="(item, index) in addressList"
      :key="index"
      @click="checkAddress(item)"
    >
      <div class="wrapper">
        <div class="address-box">
          <span v-if="item.defaulted" class="tag">默认</span>
          <span class="address">{{ item.address }} {{ item.area }}</span>
        </div>
        <div class="u-box">
          <span class="name">{{ item.name }}</span>
          <span class="mobile">{{ item.phone }}</span>
        </div>
      </div>
      <span
        class="yticon icon-bianji"
        @click.stop="addAddress('edit', item)"
      ></span>
    </div>
    <div class="add-btn" @click="addAddress('add')">新增地址</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addressList: [],
    };
  },
  created() {
    let params = this.$route.params;
    if (params.setAddress) {
      this.setAddress = params.setAddress;
    }
    this.getList();
  },
  methods: {
    //选择地址
    checkAddress(item) {
      if (this.setAddress) {
        this.setAddress(item);
        this.$router.go(-1);
      }
    },
    addAddress(type, item) {
      let query = {};
      if (item && item.id) {
        query = {
          type,
          id: item.id,
        };
      } else {
        query = {
          type,
        };
      }
      this.$router.push({
        path: "/pages/address/addressManage",
        query,
      });
    },

    getList() {
      this.$http.request(this.$http.pathMap.addressList, "get").then((res) => {
        this.addressList = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  padding-bottom: 60px;
}
.list {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background: #fff;
  position: relative;
}
.wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.address-box {
  display: flex;
  align-items: center;
  .tag {
    min-width: 40px;
    text-align: center;
    font-size: 12px;
    color: $font-color-spec;
    margin-right: 5px;
    background: #fffafb;
    border: 1px solid #ffb4c7;
    border-radius: 2px;
    padding: 2px 5px;
    line-height: 1;
  }
  .address {
    font-size: 15px;
    color: $font-color-dark;
  }
}
.u-box {
  font-size: 14px;
  color: $font-color-light;
  margin-top: 8px;
  .name {
    margin-right: 15px;
  }
}
.icon-bianji {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 20px;
  color: $font-color-light;
  padding-left: 15px;
}

.add-btn {
  position: fixed;
  left: 15px;
  right: 15px;
  bottom: 8px;
  z-index: 95;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 30px);
  height: 40px;
  font-size: 16px;
  color: #fff;
  background-color: $base-color;
  border-radius: 5px;
}
</style>
